export default function Testimonials() {
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "E-commerce Owner",
      image: "https://public.readdy.ai/ai/img_res/6545b8f503a518f932c7dfcfbb5410b3.jpg",
      content: "After implementing the Facebook Marketing strategies from this program, our online sales increased by 340% in just 3 months. The ROI has been absolutely incredible!",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "Digital Marketing Manager",
      image: "https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20with%20glasses%20wearing%20charcoal%20suit%20smiling%20confidently%20in%20contemporary%20corporate%20office%20with%20soft%20lighting%20and%20clean%20modern%20background&width=400&height=400&seq=testimonial2&orientation=squarish",
      content: "The expert guidance and proven strategies helped us reduce our ad costs by 60% while doubling our conversion rates. This is the real deal for Facebook Marketing success.",
      rating: 5
    },
    {
      name: "Emily Rodriguez",
      role: "Small Business Owner",
      image: "https://readdy.ai/api/search-image?query=friendly%20latina%20entrepreneur%20with%20long%20dark%20hair%20wearing%20professional%20white%20blouse%20smiling%20genuinely%20in%20bright%20modern%20workspace%20with%20natural%20daylight%20and%20simple%20background&width=400&height=400&seq=testimonial3&orientation=squarish",
      content: "As a small business owner, I was struggling with Facebook ads. This program transformed my approach completely. Now I'm generating consistent leads every single day!",
      rating: 5
    },
    {
      name: "David Thompson",
      role: "Marketing Consultant",
      image: "https://readdy.ai/api/search-image?query=professional%20caucasian%20business%20consultant%20with%20neat%20beard%20wearing%20dark%20blue%20suit%20smiling%20professionally%20in%20elegant%20office%20setting%20with%20soft%20ambient%20lighting%20and%20neutral%20background&width=400&height=400&seq=testimonial4&orientation=squarish",
      content: "I've tried many Facebook Marketing courses, but this one stands out. The strategies are current, practical, and most importantly - they work. My clients are seeing amazing results.",
      rating: 5
    },
    {
      name: "Lisa Anderson",
      role: "Fitness Studio Owner",
      image: "https://readdy.ai/api/search-image?query=energetic%20blonde%20businesswoman%20wearing%20professional%20teal%20blazer%20smiling%20brightly%20in%20modern%20clean%20office%20space%20with%20natural%20window%20light%20and%20minimalist%20background&width=400&height=400&seq=testimonial5&orientation=squarish",
      content: "We went from barely getting any inquiries to having a waitlist for our classes. The Facebook Marketing techniques taught here are game-changing for local businesses!",
      rating: 5
    },
    {
      name: "James Wilson",
      role: "SaaS Founder",
      image: "https://readdy.ai/api/search-image?query=confident%20tech%20entrepreneur%20with%20short%20dark%20hair%20wearing%20casual%20business%20attire%20smiling%20warmly%20in%20contemporary%20startup%20office%20with%20bright%20lighting%20and%20simple%20modern%20background&width=400&height=400&seq=testimonial6&orientation=squarish",
      content: "The ROI from implementing these Facebook Marketing strategies has been phenomenal. We've scaled from $10k to $100k monthly revenue in less than 6 months. Highly recommended!",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Success Stories
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            See how businesses like yours are achieving remarkable results with our <strong>Facebook Marketing</strong> strategies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h3 className="font-bold text-lg text-gray-900">{testimonial.name}</h3>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 text-sm leading-relaxed">
                "{testimonial.content}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-8 bg-gradient-to-r from-blue-600 to-blue-500 rounded-2xl px-12 py-8 text-white">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-sm text-white/90">Success Stories</div>
            </div>
            <div className="w-px h-16 bg-white/20"></div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">340%</div>
              <div className="text-sm text-white/90">Average ROI Increase</div>
            </div>
            <div className="w-px h-16 bg-white/20"></div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">98%</div>
              <div className="text-sm text-white/90">Client Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
